const MinusCircle = ({size = 32}) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="rounded-full p-0.5 text-white bg-red">
        <path d="M8.55566 15H24.5557V17H8.55566V15Z" fill="currentColor"/>
    </svg>
)

export default MinusCircle;